import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineSightseeingIcon from 'LuxKit/Icons/line/LineSightseeingIcon'
import type { ReactElement } from 'react'
import React from 'react'

interface Props {
  description: ReactElement | string
  isSpoof?: boolean
}

function SearchTileHighlightBanner({ description, isSpoof = false }: Props) {
  return <MessageBanner
    kind={isSpoof ? 'informational-primary' : 'promotional-primary'}
    icon={<LineSightseeingIcon />}
  >
    <strong>{description}</strong>
  </MessageBanner>
}

export default SearchTileHighlightBanner
